import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { deleteTrainingSessionTplExercise, getTrainingSessionTplExerciseSingle } from "../../../../services/training-session-tpl";
import { emptyTrainingSessionExerciseTpl, TrainingSessionExerciseTpl } from "../../../../interfaces/training-session-tpl";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface CoachTrainingSessionTplExerciseDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function CoachTrainingSessionTplExerciseDelete(props: CoachTrainingSessionTplExerciseDeleteProps) {
    const [trainingSessionTplExercise, setTrainingTplExercise] = useState<TrainingSessionExerciseTpl>(emptyTrainingSessionExerciseTpl);

    const handleDelete = () => {
        deleteTrainingSessionTplExercise(props.id)
            .then(response => {
                props.onDelete(props.id);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getTrainingSessionTplExerciseSingle(props.id)
            .then(response => {
                setTrainingTplExercise(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="training-tpl-exercise-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_training_session_exercise_tpl") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { trainingSessionTplExercise.id == 0 && 
                    <LoadingSpinner />
                }
                { trainingSessionTplExercise.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_training_session_exercise_tpl_message"
                                values={{
                                    training_session_tpl_exercise_name: trainingSessionTplExercise.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}